var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_203_138",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_203_138",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE6UlEQVR4nO1aTWhdRRS+rdUqVvyrWvxB68rGXwzIy3vzfUNeEnwKVaNk4d9S6qppajduVFxp0VX9qShduBKXrZrqQisUo7ENVURrNEHUVqlKQajGaFI5eefSIb5778x982KVHhgIuWfmzDfnZ84585LkFP1PyVp7Hsk7SG4luQvAFwB+AvC7Dvn7cwA7lWd9f3//ucnJQI1GYyWA+0nuBvAXyeMhQ+YAGCV5n6yVLDVZa88kuZnkIWdTMyT3kHyc5GCtVru2r6/vQuGVoX9fR/Ju5Xmf5B/O/O8BbBLeJQFB8jYAXzsnux/ABmPM+aFryRyZC2DCAfQVgFs7qgUALzgCJ6y1jUjLL5MDInnAOaBt0c2tXq9fQnKfCviN5PDQ0NBpHTisFcaYEQkOeljjPT09F8da/CpRt4I4SPL6PH6S6wA8CuA9klMK/BjJaQCvkuwpklmr1W4EMKlgJmUPbWvCAfGhOGwWr7V2NYAdJOcKotU8ySeFP0+2tXY1yY9SMKU1o5FpwZwAjFlrV2XxihCSnwWG3j8BvDQwMHB2zh5WOWDGS/kMyRdTc8rTRJIky0nuDb1DnLG3q6vrjAJNTyrvc6EgbnccO9cnANzTBohUO1vyZFhrb3ICgF9orlQqZ6mTipCNHqB3RQDyTZEcY8xI6i9eJkbykfSe8AixEv9/bReIDGPM1UWhmeQnyj/s4+CHfFVojLkoBggZ1tp+X5OXdCZXK8aYB3ThfUWLKvA1sYAYY+7yELksTWestfdmcgF4R5ke8gGiYTcKEF8nBvCw8r+Vl8BJWj0jtYXPotVq9Ry94GKY1jU+MiuVygWSNcs91LKeEdUq0neTACL5bQQgcyHpO5slgMxb/4+PAJ7Rj4+FABEVRzCrTwNlPqFzt7ZC+YYuemfgos9HALIjRCbJQZ23s9WG0jRgXcCaywH8EMG0DstaiSdJ9anzDrZC+Yt8FGfyXVAdL0rUCpFrTtxfR1oBWaif8xK4xdTd3X265mPtmtZMSGbbaDRWpvOiANF5uyMAGQ2R2VAgsucopiVkjOnWCrAskGMAbg6RaZtFlxzAz5nO7nsxtYoiJcdgqDxjTFems6f3QWj4dVR9pIRJ/Rhqyu7lLVdGspgAPFvmQnTmbymhjc1lZLHZ4Gt9IZZNUdwIBuDjAG2MS41REsiezBRF6nJtCHgnjYvJWnu5L5B6vX5ZGRkVTRpJzmbuk+TbIWl8xr3iBaSsNgBsUI2+mclkrX1QmSbKCNH2jS+QzPaST2ElrwBF0Weh1C3T1wWwNsBH1oauzxOl7neF0c6JPgdC1C9tTelGBgAZ6+3tvTJg/RWS7uvcTYUTVCtTvhMA3ELy5ZK3u8x5xVpbKZLD5nvMQjvI++5RFc5LU8wYc0NGirBx0TNAW0NO2xgz0qrH6zTo5oNN3mmZfpk2nKVLTvI196WpA2MWwOuy+TRldxrp25JQ0o5j2kAe00qwqNMec8yR3J76HYAPSj/Lad9qegk3fzxjTMkTR9IOAbjCUe2/MabLhOqWVK1WLw0JrbEGmua0JolJ2hfeHqshVzDmxSc7+vYu4a+TfoPm0/dAshQkJ6XvFYcjgpDUaLhModU2iVD5+YU2IGZLbF56uKPSWZfMOTkZSJrgUpwBeFrKZv0BzVHHZI7q/+TbU1JSl/m1xClK/iP0N5lBpIpWDWQfAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.74cb07f538d4cbaad997ed7a542df419.svg";
export { ForwardRef as ReactComponent };